PJQ.views.addressbook = {};

PJQ.constants.addressBook = {
    approvalFilter: {
      APPROVED: -3,
      UNAPPROVED: -4
    },
    contactStatusFilter: {
      ACTIVE: -5,
      INACTIVE: -6
    },
    directoryFilter: {
        ALL_CONTACTS: 0,
        PRIVATE_ONLY: -1,
        PUBLIC_ONLY: -2
    },
    laborStatusFilter: {
        UNION: -7,
        NON_UNION: -8,
        PREV_WAGE: -9,
        NOT_AVAILABLE: -10
    },
    miscFilter: {
        PRIMARY_CONTACT_ONLY: -11
    },
    locationTypeFilter: {
        WORK_AREA: 1,
        OFFICE_LOCATION: 2,
        BOTH: 3
    },
    view: {
        TRADES_COMPANY: 'groupcompany',
        TRADES_COMPANY_GROUP: 'groupcompany-group',
        TRADES_COMPANY_COMPANY: 'groupcompany-company',
        TRADES_COMPANY_COMPANY_CONTACT: 'groupcompany-company-contact',
        TRADES_CONTACT: 'groupcontact',
        TRADES_CONTACT_GROUP: 'groupcontact-group',
        TRADES_CONTACT_CONTACT: 'groupcontact-contact',
        COMPANY: 'company',
        COMPANY_CONTACT: 'company-contact',
        CONTACT: 'contact',
        CONTACT_GROUP: 'contactgroup'
    },
    selectionMode: {
        NONE: 'none',
        PROQUAL: 'proqual',
        MERGE: 'merge',
        ADD_TO_PROJECT: 'addToProject',
        UPDATER: 'updater'
    }
};

if (PJQ.app.module === PJQ.constants.modules.ADDRESSBOOK) {
    PJQ.app.addOldRoutes([
        {
            route: '',
            name: 'default',
            callback: function () {
                PJQ.app.router.navigate('contactsnew', {
                    trigger: true,
                    replace: true
                });
            }
        }
    ]);
}

PJQ.modules.addressBook = {
    routes: [
        {
            route: 'contacts/:contactId',
            name: 'contact',
            callback: function (contactId) {
                PJQ.app.session.project = null;
                PJQ.app.initNavigator({
                    activeItem: "contactsnew",
                    viewOptions: {
                        contactId: parseInt(contactId)
                    }
                });
            }
        },
        {
            route: 'contactsnew',
            name: 'contactsnew',
            callback: function () {
                PJQ.app.session.project = null;
                if (PJQ.app.module === PJQ.constants.modules.APP) {
                    if (PJQ.app.session.get('ownsPortal')) {
                        PJQ.app.initNavigator({
                            activeItem: "contactsnew"
                        });
                    }
                    else {
                        PJQ.app.initNavigator();
                    }
                }
                else {
                    PJQ.app.view.renderView(PJQ.views.addressbook.AddressBook);
                }
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.addressBook.routes);
